<script setup lang="ts">
/** The five-step rail (nav "Journey"): done ✓, attention dot, busy ring, number, locked padlock. */
import { computed } from 'vue';
import Icon from './Icon.vue';
import { snap, STEPS, ui, type StepId } from '@/app/state';
import { toast } from '@/app/announce';
import { go, stepState } from '@/app/navigation';

const items = computed(() => {
  void snap.value; void ui.looked; void ui.analysis.status;
  const idx = STEPS.findIndex((s) => s.id === ui.step);
  return STEPS.map((s, i) => ({ ...s, i, st: stepState(s.id), cur: s.id === ui.step, past: i < idx }));
});
function onClick(e: MouseEvent, id: StepId, locked: boolean, reason?: string) {
  e.preventDefault();
  if (locked) { toast(reason ?? 'Locked.', { tone: 'warn' }); return; }
  go(id);
}
</script>

<template>
  <nav class="rail" aria-label="Journey">
    <ol id="rail">
      <li v-for="s in items" :key="s.id" class="rail-item" :class="[`k-${s.st.kind}`, { 'is-current': s.cur, 'is-past': s.past }]">
        <a
          :href="`#${s.id}`"
          :data-step="s.id"
          :aria-current="s.cur ? 'step' : undefined"
          :aria-disabled="s.st.kind === 'locked' ? 'true' : undefined"
          :title="s.st.kind === 'locked' ? s.st.reason : undefined"
          @click="onClick($event, s.id, s.st.kind === 'locked', s.st.reason)"
        >
          <span class="rail-mark">
            <Icon v-if="s.st.kind === 'done'" name="check" />
            <Icon v-else-if="s.st.kind === 'locked'" name="lock" />
            <span v-else-if="s.st.kind === 'attn'" class="attn-dot" aria-hidden="true" />
            <span v-else-if="s.st.kind === 'busy'" class="busy-ring" aria-hidden="true" :style="{ '--p': Math.round((s.st.progress ?? 0.3) * 100) }" />
            <span v-else class="num" aria-hidden="true">{{ s.i + 1 }}</span>
          </span>
          <span class="rail-text"><span class="rail-label">{{ s.label }}</span><span class="rail-state">{{ s.st.text }}</span></span>
          <span v-if="s.st.kind === 'locked'" class="sr-only">: {{ s.st.reason }}</span>
        </a>
      </li>
    </ol>
  </nav>
</template>
